import { render, staticRenderFns } from "./DrugProviderSearchDashboardItemSba.vue?vue&type=template&id=320717a2&scoped=true&"
import script from "./DrugProviderSearchDashboardItemSba.vue?vue&type=script&lang=js&"
export * from "./DrugProviderSearchDashboardItemSba.vue?vue&type=script&lang=js&"
import style0 from "./DrugProviderSearchDashboardItemSba.vue?vue&type=style&index=0&id=320717a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320717a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
